import React, { Component, Fragment } from "react";
import "./sizing.css";
import DropDownWhiteStyle from "../../components/dropdown/dropDownWhiteStyle";
import { getFluidTypes } from "../../constants/sizing-constant";
import DryerGasSizing from "../sizing/DryerGasSizing";
import DryerAirSizing from "../sizing/DryerAirSizing";
import { Link } from "react-router-dom";
import { getproductsBySizingParameters } from "../../constants/products-constant";

export default class dryerSizing extends Component {

    state = {
        fluidTypes: [],
        selectedfliudType: "0",

        suggestedModel: "",
        suggestedModelId: ""
    };

    componentDidMount() {
        this.setState({ fluidTypes: [...getFluidTypes()] });
    };

    componentWillReceiveProps(Values) {
        this.setState({ products: Values.products });
    };

    handleFluidTypesSelect = fliudType => {
        if (fliudType) {
            this.setState({ selectedfliudType: fliudType.value });
            if (fliudType.value === "1") {
                const suggestedProducts = [...getproductsBySizingParameters("درایر", "هوا", "")]
                this.props.handler(suggestedProducts)
                return;
            }
            if (fliudType.value === "2") {
                const suggestedProducts = [...getproductsBySizingParameters("درایر", "گاز", "")]
                this.props.handler(suggestedProducts)
                return;
            }
        }
    };

    dryerHandler = (newProductList) => {
        this.props.handler(newProductList)
        return;
    }

    render() {
        return (
            <Fragment>
                <DropDownWhiteStyle
                    items={this.state.fluidTypes}
                    placeholder="نوع سیال"
                    onItemSelect={this.handleFluidTypesSelect}
                    value={this.state.selectedfliudType}
                />
                {this.state.selectedfliudType === "1" &&
                    <DryerAirSizing handler={this.dryerHandler} />
                }
                {this.state.selectedfliudType === "2" &&
                    <DryerGasSizing handler={this.dryerHandler} />
                }
            </Fragment>
        );
    }
}
